// custom imports
import { HomeState } from "."

// third party
import { create } from "zustand"
import { baseState } from "../../state/store"

export const useHomeStore = create<HomeState>((set, get) => ({
    ...baseState<HomeState>(set, get),
    reset: () =>
      set({
        loading: { on: false },
        selected: [],
        status: undefined,
      }),
}))
